import { configureStore } from '@reduxjs/toolkit'

import injectReducer from './features/injectSlice'
import scenarioReducer from './features/scenarioSlice'
import organizationReducer from './features/organizations/organizationSlice'
import playerScenarioReducer from './features/player/playerScenarioSlice'
import playerInjectReducer from './features/player/playerInjectSlice'
import authReducer from './features/auth/authSlice'
import userReducer from './features/user/userSlice'
import gameReducer from './features/player/gameSlice'
import gameStatusReducer from './features/player/gameStatusSlice'
import hotwashReducer from './features/hotwash/hotwashSlice'
import { authApi } from './services/auth/authService'

const store = configureStore({
  reducer: {
    injects: injectReducer,
    scenarios: scenarioReducer,
    organizations: organizationReducer,
    playerScenarios: playerScenarioReducer,
    playerInjects: playerInjectReducer,
    games: gameReducer,
    gameStatus: gameStatusReducer,
    hotwash: hotwashReducer,
    user: userReducer,
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(authApi.middleware)
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store